import PropTypes from 'prop-types';
import React from 'react';

// eslint-disable-next-line import/no-default-export
export default class WidgetInput extends React.Component<any> {
  state = {
    value: this.props.value,
  };

  onChange = (evt) => {
    const { onChange } = this.props;

    const {
      target: { value },
    } = evt;

    this.setState({ value });
    onChange(value);
  };

  render() {
    const { schema } = this.props;
    const { value } = this.state;

    const { type, minimum, maximum, postfix } = schema;

    return (
      <div className={`${postfix ? 'input-group' : ''}`}>
        <input
          // @ts-expect-error
          onWheel={(e) => e.target.blur()}
          className="form-control"
          onChange={this.onChange}
          value={value}
          type={type === 'integer' ? 'number' : ''}
          min={minimum}
          max={maximum}
        />
        {postfix && <span className="input-group-addon">{postfix}</span>}
      </div>
    );
  }
}

// @ts-expect-error
WidgetInput.propTypes = {
  value: PropTypes.any,
  schema: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
};
